module.exports = __webpack_public_path__ + "static/media/map12.90ad3813.webp";